'use client';

import { useEffect, useState } from 'react';

export const LEGACY_CONSENT_EVENT = 'uh-legacy-consent';
const LOCAL_STORAGE_COOKIE_CONSENT_KEY = 'COOKIE_CONSENT';

/** True only after the old banner's Accept. Same-tab updates come through the event. */
export function useLegacyCookieAccepted(): boolean {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const read = () => {
      try {
        return (
          JSON.parse(
            window.localStorage.getItem(LOCAL_STORAGE_COOKIE_CONSENT_KEY) ??
              'null',
          ) === true
        );
      } catch {
        return false;
      }
    };
    const sync = () => setAccepted(read());
    sync();
    window.addEventListener(LEGACY_CONSENT_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(LEGACY_CONSENT_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return accepted;
}
